// @flow

import * as React from 'react';

import { Button, Checkbox, Title, Tooltip } from '../core';
import {
  UI_PERMISSIONS_HEADING,
  UI_RESOURCE_OPTIONS,
  READ_PERMISSION,
  WRITE_PERMISSION
} from '../../support/accessControlConstants';
import type { Permissions } from '../../../main/types/accessControlTypes';

type Props = {
  disabled: boolean,
  displayTitle?: boolean,
  onCheckboxClick: (
    resourceName: string,
    boxType: 'read' | 'write'
  ) => () => void,
  onEditClick: () => void,
  permissions: Permissions
};

class PermissionsTable extends React.PureComponent<Props> {
  static defaultProps = {
    permissions: {}
  };

  render() {
    const props = this.props;

    return (
      <div className="permissions-section">
        {props.displayTitle ? (
          <Title label={UI_PERMISSIONS_HEADING} labelClassName="h_pt-10" />
        ) : null}
        <table className="permissions-table">
          <thead>
            <tr className="permissions-table__heading">
              <th />
              <th className="permissions-table__heading-cell">View</th>
              <th className="permissions-table__heading-cell">Edit</th>
              <th className="permissions-table__heading-pencil">
                <Button
                  onClick={props.onEditClick}
                  type="secondary"
                  size="no-miw"
                  className="pencil-button"
                  testid="permissions-table__edit"
                >
                  <i className="material-icons pencil-button-icon">mode_edit</i>
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {UI_RESOURCE_OPTIONS.map(
              (resource: {
                id: string,
                label: string,
                tooltip: string,
                read_possible: boolean,
                write_possible: boolean
              }) => (
                <tr key={resource.id} className="permissions-table__row">
                  <td className="permissions-table__label">
                    {resource.label}
                    <Tooltip title={resource.tooltip} className="h_mb-5" />
                  </td>
                  <td className="permissions-table__cell">
                    {resource.read_possible && (
                      <Checkbox
                        checked={
                          props.permissions[resource.id] >= READ_PERMISSION
                        }
                        disabled={props.disabled}
                        onChange={props.onCheckboxClick(resource.id, 'read')}
                        id={`read_${resource.id}`}
                        className="permissions-table__checkbox"
                      />
                    )}
                  </td>
                  <td className="permissions-table__cell">
                    {resource.write_possible && (
                      <Checkbox
                        checked={
                          props.permissions[resource.id] >= WRITE_PERMISSION
                        }
                        disabled={props.disabled}
                        onChange={props.onCheckboxClick(resource.id, 'write')}
                        id={`write_${resource.id}`}
                        className="permissions-table__checkbox"
                      />
                    )}
                  </td>
                  <td className="permissions-table__cell" />
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default PermissionsTable;
